import React from 'react';

import * as ROUTES from "../Constants/routes";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagramSquare, faPatreon } from "@fortawesome/free-brands-svg-icons";
import remind from "./remind.png";

function Footer() {
    return (
      <div className="footerContainer">
        <footer
          className="page-footer font-small"
          style={{ backgroundColor: "#1C2331" }}
        >
          <div style={{ backgroundColor: "#138808" }}>
            <div className="container">
              {/* Grid row*/}
              <div className="row py-4 d-flex align-items-center">
                {/* Grid column */}
                <div className="col-md-6 col-lg-6 text-center text-md-left mb-4 mb-md-0">
                  <h6 className="mb-0">Connect with us!</h6>
                </div>
                {/* Grid column */}
                {/* Grid column */}
                <div className="col-md-6 col-lg-6 text-center text-md-right">
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.patreon.com/envatohouston2021"
                    style={{ color: "black" }}
                  >
                    <FontAwesomeIcon
                      icon={faPatreon}
                      size="2x"
                      className="white-text mr-4"
                    />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="mailto: envato.houston21@gmail.com"
                    style={{ color: "black" }}
                  >
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="2x"
                      className="white-text mr-4"
                    />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.instagram.com/envatohouston2021/"
                    style={{ color: "black" }}
                  >
                    <FontAwesomeIcon
                      icon={faInstagramSquare}
                      size="2x"
                      className="white-text mr-4"
                    />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.remind.com/classes/envatoh/"
                    style={{ color: "black" }}
                  >
                    <img
                      width="28"
                      height="28"
                      src={remind}
                      alt="Remind"
                      className="white-text"
                      style={{ marginTop: "-16px", borderRadius: "3px" }}
                    />
                  </a>
                </div>
                {/* Grid column */}
              </div>
              {/* Grid row*/}
            </div>
          </div>
          {/* Footer Links */}
          <div className="container text-center text-md-left mt-5">
            {/* Grid row */}
            <div className="row mt-3">
              {/* Grid column */}
              <div
                className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4"
                align="center"
              >
                {/* Content */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.HOME}>Home</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div
                className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4"
                align="center"
              >
                {/* Links */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.ABOUT}>About</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div
                className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4"
                align="center"
              >
                {/* Links */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.SUPPORTUS}>Support Us</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div
                className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4"
                align="center"
              >
                {/* Content */}
                <h6 className="text-uppercase font-weight-bold">
                  <a href={ROUTES.SCHEDULE}>Schedule</a>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px", backgroundColor: "#6351ce" }}
                />
              </div>
              {/* Grid column */}
            </div>
            {/* Grid row */}
          </div>
          {/* Footer Links */}
        </footer>
      </div>
    );
}

export default Footer;